export default "__VITE_ASSET__aece47ec__"